

export const all_routes = {

  homeOne: "/index",
  register: "/authentication/register",
  login: "/authentication/login",
  forgotPassword: "/authentication/forgot-password",
  resetPassword: "/authentication/reset-password",
  aboutUs: "/pages/aboutUs",
  faq: "/pages/faq",
  gallery: "/pages/gallery",
  invoice: "/pages/invoice-details",
  ourTeam: "/pages/our-team",
  testimonial: "/pages/testimonial",
  termsConditions: "/pages/terms-condition",
  privacyPolicy: "/pages/privacy-policy",
  maintenance: "/pages/maintenance",
  comingSoon: "/pages/coming-soon",
  error404: "/pages/error-404",
  error500: "/pages/error-500",
  contactUs: "/contact-us",
  changePassword: "/pages/change-password",
  booking: "/pages/booking",
  bookingCheckout: "/pages/booking-checkout",
  bookingDetail: "/pages/booking-detail",
  bookingPayment: "/pages/booking-payment",
  bookingSuccess: "/pages/booking-success",
  paymentPending: "/pages/payment-pending",
  invoiceDetails: "/pages/invoice-details",
  paymentSuccess: "/payment/success",
  paymentCancel: "/payment/cancel",
  userBookingComplete: "/user/user-booking-complete",
  userBookingInprogress: "/user/user-booking-inprogress",
  userBookings: "/user/user-bookings",
  userMessages: "/user/user-messages",
  userReviews: "/user/user-reviews",
  userWishlist: "/user/user-wishlist",
  userPayment: "/user/user-payment",
  userSettings: "/user/settings/user-settings",
  userSecurity: "/user/user-security",
  preference: "/user/user-preferences",
  notification: "/user/user-notifications",
  userIntegration: "/user/user-integration",
  userWallet: "/user/user-wallet",
  userBookingCancelled: "/user/user-booking-cancelled",
  userBookingUpcoming: "/user/user-booking-upcoming",
  BookingCompleteCalendar: "/user/booking-complete-calendar",
  BookingCancelledCalendar: "/user/booking-cancelled-calendar",
  BookingInprogressCalendar: "/user/booking-inprogress-calendar",
  BookingUpcomingCalendar: "/user/booking-upcoming-calendar",
  BookingCalendar: "/user/bookings-calendar",
  userPendingBookings: "/user/bookings-pendings",
  blogList: "/blog/blog-list",
  blogGrid: "/blog/blog-grid",
  blogDetails: "/blog/blog-details",
  listingGrid: "/listings/viewcarslist",
  listingDetails: "/listings/detailcarview",
  howItWorks: "/pages/how-it-works",
  pricing: "/pages/pricing",
  whyUs: "/pages/why-us",
  userAgreement: "/pages/userAgreement",
};
